export default "__VITE_ASSET__1eba60f4__"